import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const uomRBAC = {
  pageID: 'a68bb273318b5822836dbc78c690e0f6',
  elementID: {
    BtnToggleStatus: '78ea878dc4ca799a973425d4cc51e9a0',
    BtnCreateUom: '246afc06f3791a6e3e29a391943a4c5b',
    BtnUpdateUom: '16bff2bae1791a10bef2d2a69ad1e596',
  },
} as const

export const useRBACUomPage = createUseRBAC(uomRBAC.elementID)

export type UseRBACUomPageType = ReturnType<typeof useRBACUomPage>
